import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './channel.mutations';
import actions from './channel.actions';

Vue.use(Vuex);

export default {
  namespaced: true,
  mutations,
  actions,
  state: {
    currentChannel: null,
    ownChannels: [],
    waitingChannels: [],
    unreadChannels: {}
  },
  getters: {}
};
